import { render, staticRenderFns } from "./ratioIn-add-or-update.vue?vue&type=template&id=662d9cde&scoped=true"
import script from "./ratioIn-add-or-update.vue?vue&type=script&lang=js"
export * from "./ratioIn-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./ratioIn-add-or-update.vue?vue&type=style&index=0&id=662d9cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d9cde",
  null
  
)

export default component.exports